//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AdvancedOptionsFromFile",1,0],[0,"AdvancedOptionsFromPart",1,0],[0,"BoardPropertyFile",1,0],[0,"BoardStackup",1,0],[0,"BoardStackupFile",1,0],[0,"BoardStackupNumber",1,0],[0,"BoardStackupODBFolder",1,0],[0,"BoardStackupRevision",1,0],[0,"CalculationPointsPrecision",1,0],[1,"DefaultHolePlatingThickness",0,"Expression",0],[0,"DielectricNxMaterial",1,0],[0,"DielectricPcbMaterial",1,0],[0,"Generator",1,0],[0,"MaterialsFrom",1,0],[0,"NumberOfCalculationPoints",1,0],[0,"ReadViasFromFile",1,0],[0,"StructuralAlgorithm",1,0],[0,"ThermalAlgorithm",1,0],[0,"TraceNxMaterial",1,0],[0,"TracePcbMaterial",1,0],[0,"UseCurrentWorkPart",1,0],[0,"ViaNxMaterial",1,0],[0,"ViaPcbMaterial",1,0],[0,"ViewCalculationReport",1,0]],[],[]];
SPLM.PcbExchange.BoardPropertiesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.BoardPropertiesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.BoardPropertiesBuilder.GeneratorOption = Object.freeze({
    "BoardProperties" : "BoardProperties", "EDABridge" : "EDABridge"});

SPLM.PcbExchange.BoardPropertiesBuilder.BoardStackupOption = Object.freeze({
    "FromPart" : "FromPart", "FromFile" : "FromFile", "FromODB" : "FromODB", "FromTeamcenter" : "FromTeamcenter"});

SPLM.PcbExchange.BoardPropertiesBuilder.MaterialsFromOption = Object.freeze({
    "PCBMaterialLibrary" : "PCBMaterialLibrary", "NXMaterialLibrary" : "NXMaterialLibrary"});

SPLM.PcbExchange.BoardPropertiesBuilder.ThermalAlgorithmOption = Object.freeze({
    "Discretized" : "Discretized", "Equivalent" : "Equivalent"});

SPLM.PcbExchange.BoardPropertiesBuilder.StructuralAlgorithmOption = Object.freeze({
    "Equivalent" : "Equivalent"});

export default SPLM;